import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import "./DrawerMenu.css";
import { trackClick, getElementName } from "../../../../../utils/analytics/analytics";
import { ANALYTICS_MODULES, ANALYTICS_SECTIONS, ANALYTICS_ELEMENT_TYPES } from "../../../../../constants/analyticsConstants";

function DrawerMenu({isOpen, onClose, options = [], footer = null}) {
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <>
            <div
                className={`drawer__overlay ${isOpen ? "open" : ""}`}
                onClick={onClose}
            />

            <div className={`drawer__panel ${isOpen ? "open" : ""}`}>
                <button 
                    className="drawer__close" 
                    onClick={() => {
                        trackClick({
                            module: ANALYTICS_MODULES.LANDING,
                            section: ANALYTICS_SECTIONS.LANDING_HEADER,
                            elementName: getElementName(ANALYTICS_ELEMENT_TYPES.BUTTON, ANALYTICS_SECTIONS.LANDING_HEADER, 'close_drawer'),
                            elementType: ANALYTICS_ELEMENT_TYPES.BUTTON
                        });
                        onClose();
                    }}
                >
                    ✕
                </button>

                <nav className="drawer__content">
                    {options.map(({option, link}, idx) => {
                        // Determinar el nombre semántico basado en la opción
                        const semanticName = option.toLowerCase().replace(/\s+/g, '_');
                        const isExternalLink = link.startsWith('http');
                        
                        if (isExternalLink) {
                            return (
                                <a 
                                    key={idx} 
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                        trackClick({
                                            module: ANALYTICS_MODULES.LANDING,
                                            section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                            elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, semanticName),
                                            elementType: ANALYTICS_ELEMENT_TYPES.LINK
                                        });
                                    }}
                                >
                                    {option}
                                </a>
                            );
                        }
                        
                        return (
                            <button
                                key={idx}
                                type="button"
                                className="drawer__content-link"
                                onClick={() => {
                                    trackClick({
                                        module: ANALYTICS_MODULES.LANDING,
                                        section: ANALYTICS_SECTIONS.LANDING_HEADER,
                                        elementName: getElementName(ANALYTICS_ELEMENT_TYPES.LINK, ANALYTICS_SECTIONS.LANDING_HEADER, semanticName),
                                        elementType: ANALYTICS_ELEMENT_TYPES.LINK
                                    });
                                    navigate(link);
                                    onClose();
                                }}
                            >
                                {option}
                            </button>
                        );
                    })}
                </nav>

                {footer && <div className="drawer__footer">{footer}</div>}
            </div>
        </>
    );
}

export default DrawerMenu;
